import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useChecklistMaquinaEquipListaViewModel } from "../../viewModels/checklist_maquina_equip_lista_view_model";
import { GenerateChecklistMaquinaEquipColumnsDefinition } from "./columns";
import { ChecklistMaquinaEquipModel } from "../../../domain/models/checklist_maquina_equip";
import { ChecklistMaquinaEquipModal } from "./components/checklist_maquina_equip_modal";

/**
 * ChecklistMaquinaEquipLista
 */

export const ChecklistMaquinaEquipLista = () => {
  const viewModel = useChecklistMaquinaEquipListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateChecklistMaquinaEquipColumnsDefinition({
      onActionEditar: viewModel.handleChecklistMaquinaEquipModal,
      onActionDeletar: viewModel.handleChecklistMaquinaEquipDeleteModal,
      onEnterChecklists: viewModel.handleEnterChecklist,
    });
  }, [
    viewModel.handleChecklistMaquinaEquipModal,
    viewModel.handleChecklistMaquinaEquipDeleteModal,
    viewModel.handleEnterChecklist,
  ]);

  // const pinnedColumns = useMemo((): GridPinnedColumnFields | undefined => {
  //   return viewModel.checklist && viewModel.checklistServicos.length > 0
  //     ? { right: ['idChecklistMaquinaEquip', 'copiar'] }
  //     : undefined;
  // }, [
  //   viewModel.checklist,
  //   viewModel.checklistServicos,
  // ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">

              <div className="w-[115px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onMouseDown={e => viewModel.handleChecklistMaquinaEquipModal(null, true)}>
                  Novo Item
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Typography className="text-primary-green">
            Checklist de Máquina/equipamento
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Checklist de Máquina/equipamento</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2"></div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Header
                  codigo={viewModel.filters.codigo}
                  descricao={viewModel.filters.descricao}
                  status={viewModel.filters.status}
                  onCodigoChange={viewModel.handleCodigoChange}
                  onDescricaoChange={viewModel.handleDescricaoChange}
                  onStatusChange={viewModel.handleStatusChange}
                  onClearFilters={viewModel.handleClearFilters}
                />

                <Stack spacing={0}>
                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                  <StyledDataGrid
                    tableName="checklist_servico_lista"
                    disableColumnMenu={false}
                    getRowId={(row: ChecklistMaquinaEquipModel) => row.idChecklistMaquinaEquip}
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.checklistMaquinaEquips}
                    rowCount={viewModel.checklistMaquinaEquips.length}
                    pinnedColumns={viewModel.checklistMaquinaEquips.length > 0 ? { right: ['idChecklistMaquinaEquip', 'copiar'] } : undefined}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                    sx={{
                      '& .ia-header': {
                        backgroundColor: "#26C281",
                      }
                    }}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />
                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <ChecklistMaquinaEquipModal
        open={viewModel.checklistMaquinaEquipModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedChecklistMaquinaEquip={viewModel.selectedChecklistMaquinaEquip ?? null}
        onClose={viewModel.handleChecklistMaquinaEquipModal}
        onSubmit={viewModel.handleChecklistMaquinaEquipSubmit}
      />

      {/* <CopyChecklistServicoModal
          open={viewModel.copyChecklistServicoModal}
          saving={viewModel.saving}
          loading={viewModel.loading}
          selectedChecklistServico={viewModel.selectedChecklistServico ?? null}
          onClose={viewModel.handleCopyChecklistServicoModal}
          onSubmit={viewModel.handleCopyChecklistServicoSubmit}
        /> */}

      <DeleteDialog
        open={viewModel.checklistMaquinaEquipDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleChecklistMaquinaEquipDeleteModal(null, false)}
        onDelete={viewModel.handleChecklistMaquinaEquipDeleteSubmit}
      />

      {/* <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      /> */}

    </>
  );
}